module.exports = __webpack_public_path__ + "static/img/s61.686c3e6b.png";